export { default } from "./ViewPageFooter";
